<div class="ui_person-badge ui_person-badge--{{ align }}">
  @if (person) {
    <div
      class="ui_person-badge__badge ui_person-badge__badge--{{ size }} [ on-surface-variant ]"
      [class.ui_person-badge__badge--show-border]="showBorder"
      >{{ person | personInitials }}
      @if (person.avatar) {
        <img data-cy="person-badge-avatar" [src]="person.avatar" alt="avatar" />
      }
    </div>
  } @else {
    <campus-icon
      class="ui_person-badge__badge ui_person-badge__badge--{{ size }} ui_person-badge__badge__no-account-icon"
      [svgIcon]="'account'"
    ></campus-icon>
  }
  @if (showText) {
    <div class="ui_person-badge__display ui_person-badge__display--{{ size }}">
      <div data-cy="person-badge-display-name" class="ui_person-badge__display__name ui-body-1">{{
        person?.displayName
      }}</div>
      @if (subText) {
        <div data-cy="person-badge-sub-text" class="ui_person-badge__display__subtext ui-caption">{{
          subText
        }}</div>
      }
      @if (showEmail) {
        <a class="ui_person-badge__display__email ui-caption" [href]="'mailto:' + person?.email">{{
          person?.email
        }}</a>
      }
    </div>
  }
</div>
